const updateItems = [
  {
    time: '15:42',
    title: '某当红小生被拍到深夜与神秘女子同行',
    desc: '狗仔队最新偷拍画面曝光，当事人尚未回应此事，网友已开始各种猜测与分析。',
  },
  {
    time: '14:18',
    title: '知名编剧发文暗讽圈内潜规则',
    desc: '一位资深编剧在社交平台发布长文，疑似暗指行业内不为人知的规则，引发圈内人士共鸣。',
  },
  {
    time: '12:55',
    title: '某女团成员疑似整容风波升级',
    desc: '粉丝发现近期照片与早期影像存在明显差异，该成员后援会已发声明澄清但争议仍在继续。',
  },
  {
    time: '11:30',
    title: '热播剧原著作者与编剧互撕',
    desc: '原著作者公开发文指责编剧乱改剧情，编剧随后回应称改编已获授权，双方各执一词。',
  },
  {
    time: '09:45',
    title: '某综艺节目录制现场意外中断',
    desc: '因嘉宾突发身体不适，节目录制被迫中断，制作方表示将择期补录，观众表示关切。',
  },
  {
    time: '08:20',
    title: '知名歌手新专辑被指抄袭',
    desc: '有网友指出某歌手新专辑主打歌与国外作品高度相似，唱片公司暂未对外做出正式回应。',
  },
  {
    time: '昨天 22:10',
    title: '某品牌代言人合同纠纷曝光',
    desc: '内部人士透露某国际品牌与代言人之间存在合同争议，可能影响后续合作计划。',
  },
  {
    time: '昨天 19:35',
    title: '网传某剧组片场矛盾激化',
    desc: '多位工作人员匿名爆料称某剧组现场气氛紧张，主演之间的矛盾已影响正常拍摄进度。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          51吃瓜爆料实时更新快讯
        </p>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="flex flex-col gap-6">
            {updateItems.map((item, i) => (
              <div key={i} className="relative pl-12">
                <div className="absolute left-0 top-1 w-[9px] h-[9px] rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <span className="inline-block text-xs font-medium text-primary-500 mb-1.5">{item.time}</span>
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}